import { Component, OnInit } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DataserviceService } from '../../dataservice.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
// import { jsPDF } from 'jspdf';
import * as pdfjsLib from 'pdfjs-dist';
// import * as pdfjsViewer from 'pdfjs-dist/web/pdf_viewer';
import { FormControl, FormGroup, Validators } from '@angular/forms';
(pdfjsLib as any).GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';

@Component({
  selector: 'app-signature-assignment',
  templateUrl: './signature-assignment.component.html',
  styleUrls: ['./signature-assignment.component.css']
})
export class SignatureAssignmentComponent implements OnInit {

  documentName: string = '';
  assignmentType: any;
  loadingDoc: boolean = false;
  showUploader: boolean = true;
  fileType: any;
  file: any;
  fieldModal: boolean = false;

  pendingField: {
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
  } | null = null;

  isDrawing = false;
  drawingMode: boolean = false;
  startX = 0;
  startY = 0;

  currentCanvas: HTMLCanvasElement | null = null;
  ctx: CanvasRenderingContext2D | null = null;
  pdfPages: { [pageNum: number]: any } = {};
  pdfViewports: { [pageNum: number]: any } = {};
  fields: any[] = [];
  fieldForm: FormGroup;
  docForm: FormGroup;
  modalData: any;
  currentPageNum: any;
  editMode: boolean = false;

  constructor( 
    private msg: NzMessageService,
    private dataService: DataserviceService,
    private modalRef: NzModalRef) {

      this.fieldForm = new FormGroup({
        type: new FormControl(null, [Validators.required]),
        name: new FormControl(null, [Validators.required]),
        placeholder: new FormControl(null),
      });

      this.docForm = new FormGroup({
        name: new FormControl(null, [Validators.required]),
        type: new FormControl(null, [Validators.required]),
        distributors: new FormControl(null),
        companies: new FormControl(null)
      })
      
    }

  ngOnInit() {
    this.modalData = this.modalRef.getConfig().nzData;
    console.log(this.modalData)
  }

  //Handles the upload of the file, and sets it up for the modal
  handleBeforeUpload = (file: NzUploadFile): boolean => {
    this.showUploader = false;
    if(file.type?.includes('application/pdf')) {
      this.loadingDoc = true;
      this.fileType = 'pdf'
      this.file = file;
      this.renderPDF(file as unknown as File)
    }
    return false;
  };

  //Renders the file to the modal and sets up the scaling
  async renderPDF(file: File) {
    const reader = new FileReader();
  
    reader.onload = async () => {
      const typedarray = new Uint8Array(reader.result as ArrayBuffer);
      const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;
  
      const container = document.getElementById('pdf-container');
      if (!container) {
        return;
      }
  
      container.innerHTML = ''; 
  
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const scale = 1.5;
        const viewport = page.getViewport({ scale });
        
        this.pdfPages[pageNum] = page;
        this.pdfViewports[pageNum] = viewport;
        
        // Create container div to hold both canvases stacked
        const pageContainer = document.createElement('div');
        pageContainer.style.position = 'relative';
        pageContainer.style.margin = '1rem auto';
        pageContainer.style.width = `${viewport.width}px`;
        pageContainer.style.height = `${viewport.height}px`;
        
        // Create bottom canvas for PDF page rendering
        const pdfCanvas = document.createElement('canvas');
        pdfCanvas.id = `pdfpage-${pageNum}`;
        pdfCanvas.width = viewport.width;
        pdfCanvas.height = viewport.height;
        pdfCanvas.style.display = 'block';
        
        // Create overlay canvas for drawing selection rectangles
        const overlayCanvas = document.createElement('canvas');
        overlayCanvas.id = `overlay-${pageNum}`;
        overlayCanvas.width = viewport.width;
        overlayCanvas.height = viewport.height;
        overlayCanvas.style.position = 'absolute';
        overlayCanvas.style.top = '0';
        overlayCanvas.style.left = '0';
        overlayCanvas.style.pointerEvents = 'auto';  // To capture mouse events
        
        // Append canvases to the container
        pageContainer.appendChild(pdfCanvas);
        pageContainer.appendChild(overlayCanvas);
        
        // Append container to your main PDF container div
        container.appendChild(pageContainer);
        
        // Render the PDF page on the pdfCanvas
        const pdfCtx = pdfCanvas.getContext('2d')!;
        await page.render({ canvasContext: pdfCtx, viewport }).promise;
        
        // Setup mouse event listeners on overlayCanvas for drawing
        overlayCanvas.onmousedown = (event) => this.mouseDown(event, overlayCanvas, pageNum);
        overlayCanvas.onmousemove = (event) => this.mouseMove(event, overlayCanvas, pageNum);
        overlayCanvas.onmouseup = (event) => this.mouseUp(event, overlayCanvas, pageNum);

        if (overlayCanvas) {
          overlayCanvas.addEventListener('click', (event) => this.onOverlayCanvasClick(event, pageNum));
        }
        
      }
  
      this.loadingDoc = false;
    };
  
    reader.readAsArrayBuffer(file);
  }

  //Click event on drawn fields so we can delete if we want
  onOverlayCanvasClick(event: MouseEvent, pageNum: number) {
    const overlayCanvas = event.currentTarget as HTMLCanvasElement;
    const rect = overlayCanvas.getBoundingClientRect();
  
    const clickX = (event.clientX - rect.left);
    const clickY = (event.clientY - rect.top);
  
    // Find the field clicked on
    const clickedField = this.fields.find(field =>
      field.pageNum === pageNum &&
      clickX >= field.x &&
      clickX <= field.x + field.width &&
      clickY >= field.y &&
      clickY <= field.y + field.height
    );
  
    if (clickedField) {
      if (confirm(`Delete field "${clickedField.name || clickedField.type}"?`)) {
        this.fields = this.fields.filter(f => f !== clickedField);
        this.redrawOverlayCanvas(pageNum);
      }
    }
  }

  //Sets ability to delete, maybe edit in the future
  editAction() {
    this.editMode = !this.editMode;
    if( this.drawingMode ) {
      this.drawingMode = false
    } 
    const overlays = document.querySelectorAll('canvas[id^="overlay-"]');
    overlays.forEach((canvas) => {
      (canvas as HTMLCanvasElement).style.cursor = this.editMode ? 'pointer' : 'default';
    });
  
    if (this.currentCanvas) {
      this.currentCanvas.style.cursor = this.editMode ? 'pointer' : 'default';
      this.currentCanvas.style.pointerEvents = this.editMode ? 'auto' : 'none';
    }
  }

  //Sets drawing mode
  setAction() {
    this.drawingMode = !this.drawingMode;
    if( this.editMode ) {
      this.editMode = false
    } 
    const overlays = document.querySelectorAll('canvas[id^="overlay-"]');
    overlays.forEach((canvas) => {
      (canvas as HTMLCanvasElement).style.cursor = this.drawingMode ? 'crosshair' : 'default';
    });
  
    if (this.currentCanvas) {
      this.currentCanvas.style.cursor = this.drawingMode ? 'crosshair' : 'default';
      this.currentCanvas.style.pointerEvents = this.drawingMode ? 'auto' : 'none';
    }
  }
  
  //mouseDown event for when we first start drawing
  mouseDown(event: MouseEvent, canvas: HTMLCanvasElement, pageNum: number) {
    if (!this.drawingMode) return; // only start drawing if drawingMode is enabled
  
    this.isDrawing = true;
    this.currentCanvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.currentPageNum = pageNum;

    canvas.style.cursor = 'crosshair';
  
    const rect = canvas.getBoundingClientRect();
    this.startX = (event.clientX - rect.left);
    this.startY = (event.clientY - rect.top);
  }
  
  //mouseMove event moves the rectangle
  mouseMove(event: MouseEvent, canvas: HTMLCanvasElement, pageNum: number) {
    if (!this.isDrawing || canvas !== this.currentCanvas) return;
  
    const rect = canvas.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;
  
    const width = mouseX - this.startX;
    const height = mouseY - this.startY;
  
    this.ctx!.clearRect(0, 0, canvas.width, canvas.height);

    this.redrawOverlayCanvas(pageNum)
  
    // Draw the current rectangle in-progress with a different style (optional)
    this.ctx!.beginPath();
    this.ctx!.lineWidth = 2;
    this.ctx!.strokeStyle = 'rgba(255, 0, 0, 0.8)'; // slightly transparent red for subtlety
    this.ctx!.setLineDash([6, 4]); // dashed line with 6px dash, 4px gap
    this.ctx!.shadowColor = 'rgba(0, 0, 0, 0.3)'; // subtle shadow for depth
    this.ctx!.shadowBlur = 4;
    this.ctx!.shadowOffsetX = 1;
    this.ctx!.shadowOffsetY = 1;
    this.ctx!.rect(this.startX, this.startY, width, height);
    this.ctx!.stroke();
    this.ctx!.setLineDash([]); // reset dash pattern so it doesn't affect other drawings
    this.ctx!.shadowBlur = 0; 
  }
  
  //mouseUp event concludes the drawing and draws the error which opens modal
  mouseUp(event: MouseEvent, canvas: HTMLCanvasElement,  pageNum: number) {
    if (!this.isDrawing || canvas !== this.currentCanvas) return;
  
    this.isDrawing = false;
  
    const rect = canvas.getBoundingClientRect();
    const endX = event.clientX - rect.left;
    const endY = event.clientY - rect.top;
  
    const x = Math.min(this.startX, endX);
    const y = Math.min(this.startY, endY);
    const width = Math.abs(endX - this.startX);
    const height = Math.abs(endY - this.startY);

    this.pendingField = {
      pageNum,
      x,
      y,
      width,
      height,
    };
  
    this.openFieldLabelModal()
  
  }

  //have to redrawFields when we make changes to them
  redrawOverlayCanvas(pageNum: number) {
    const overlayCanvas = document.getElementById(`overlay-${pageNum}`) as HTMLCanvasElement;
    if (!overlayCanvas) return;
  
    const ctx = overlayCanvas.getContext('2d');
    if (!ctx) return;
  
    ctx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height);
  
    const fieldsForPage = this.fields.filter(f => f.pageNum === pageNum);
    fieldsForPage.forEach(field => {
      // Draw filled background (light gray)
      ctx.fillStyle = 'lightgray';
      ctx.fillRect(field.x, field.y, field.width, field.height);
    
      // Draw dashed black border
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 2;
      ctx.setLineDash([5, 3]); // dash pattern
      ctx.strokeRect(field.x, field.y, field.width, field.height);
      ctx.setLineDash([]); // reset dash pattern
    
      // Draw centered bold text for non-checkbox fields
      if (field.type !== 'checkbox') {
        ctx.fillStyle = 'black';
        ctx.font = '16px sans-serif';
        ctx.textBaseline = 'middle';
    
        const text = field.placeholder || field.name || field.type || 'Field';
        const textWidth = ctx.measureText(text).width;
        const centerX = field.x + field.width / 2;
        const centerY = field.y + field.height / 2;
    
        ctx.fillText(text, centerX - textWidth / 2, centerY);
      }
    })
  }
  
  //our spinner
  loadingMsg(msg: any) {
    this.loadingDoc = true;
    this.msg.loading(`${msg}..`, { nzDuration: 0});
  }

  //closes spinner
  closeMsg() {
    this.loadingDoc = false;
    this.msg.remove()
  }

  //opens the field modal
  openFieldLabelModal() {
    this.fieldModal = true;
  }

  //submites the newley drawn field that had info field out in the modal
  submitFieldLabel() {
    if (this.fieldForm.invalid || !this.pendingField) return;
  
    const fieldData = {
      ...this.pendingField,
      ...this.fieldForm.value,
    };
  
    this.fields.push(fieldData);
  
    // Redraw overlay so the new field appears immediately
    this.redrawOverlayCanvas(fieldData.pageNum);
  
    this.closeFieldLabelModal();
  }
  
  //handles when the modal cancel button is pressed
  closeFieldLabelModal() {
    this.fieldModal = false;
    this.pendingField = null;
    this.fieldForm.reset();

    if (this.currentCanvas) {
      const ctx = this.currentCanvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, this.currentCanvas.width, this.currentCanvas.height);
  
        this.redrawOverlayCanvas(this.currentPageNum)
      }
    }
  }
  
  //saves the template to the backend
  async saveTemplate() {
    if(this.docForm.valid) {
      this.loadingMsg('Saving Document')


      const payload = {
        filePath: `template-documents/${this.documentName.trim()}.pdf`, 
        fields: this.fields, 
        name: this.docForm.get('name')?.value.trim(),
        originalCanvasWidth: this.pdfViewports[1]?.width, 
        originalCanvasHeight: this.pdfViewports[1]?.height,
        is_mandatory: true,
        company: this.docForm.get('companies')?.value,
        distributor: this.docForm.get('distributors')?.value
      };

      const pdfBlob = this.file as unknown as Blob;

      const res = await this.dataService.uploadSignedDoc(payload.filePath, pdfBlob);

      this.dataService.postData(payload, 'templates/create')
        .subscribe({
          next: (res: any) => {
            this.closeMsg();
            this.closeFieldLabelModal();
            this.modalRef.close();
          }
        })
        
    } else {
      alert('Please enter a document name/Pick a assignment type!')
    }
  }

}
